import styled from '@emotion/styled';
import { Space } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import {
  FaChartArea,
  FaMoneyBillWaveAlt,
  FaUser,
  FaUserTie,
} from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { AssetManagerType } from '../../../../redux/userStore/reducer';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { getSAdminReporting } from '../../../dashboard/network';
import { Layout } from '../../../shared/Layout';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }

  .kpi-box {
    height: 80px;
    width: 290px;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.3);
    padding: 10px;
    margin-right: 10px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${YELLOW};

    .title {
      color: white;
      font-family: Poppins-L;
    }

    .value {
      color: white;
      font-weight: bold;
      font-family: Poppins-B;
    }
  }
`;

export const DashboardPage = () => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [donnees, setDonnees] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showDrawer1, setShowDrawer1] = useState(false);
  const [showDrawer2, setShowDrawer2] = useState(false);
  const [assetManager, setAssetManager] = useState<AssetManagerType[]>([]);
  const [filterClient, setFilterClient] = useState<AssetManagerType[]>([]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    getSAdminReporting().then(({ data }) => {
      setDonnees(data);
      console.log(data);
    });
  };
  const KPIContainer = ({
    title,
    value,
    icon,
  }: {
    title: string;
    value: string;
    icon: ReactNode;
  }) => {
    return (
      <div className='kpi-box'>
        <div>{icon}</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <div className='title'>{title}</div>
          <div className='value'>{value}</div>
        </div>
      </div>
    );
  };

  return (
    <Layout>
      <Container>
        <div className='content'>
          <div style={{ marginTop: 0 }}>
            <h2 style={{ color: 'white' }}>Reporting</h2>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 5,
              }}
            ></div>
            <Space>
              <KPIContainer
                title="Nombre d'utilisateurs"
                value={donnees.assets || '--'}
                icon={<FaUser size={35} color='#1b263b' />}
              />
              <KPIContainer
                title='Nombre de clients'
                value={donnees.clients || '--'}
                icon={<FaUserTie size={35} color='#1b263b' />}
              />
              <KPIContainer
                title='Nombre de bonds disponibles'
                value={donnees.bonds || '--'}
                icon={<FaMoneyBillWaveAlt size={35} color='#1b263b' />}
              />
              <KPIContainer
                title="Chiffre d'affaire"
                value={donnees.chiffre_a || '--'}
                icon={<FaChartArea size={35} color='#1b263b' />}
              />
            </Space>
          </div>
        </div>
        ;
      </Container>
    </Layout>
  );
};
